<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Dynamics Messages</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card p-mt-2">
                <DataTable :value="dynamicsmessage" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Dynamic Message" icon="pi pi-plus" @click="toDynamicMessage" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Module" field="sm3" class="p-text-capitalize" headerStyle="width: 20%">
                    </Column>
                    <Column header="Screen Title" field="sm4" class="p-text-capitalize" headerStyle="width: 20%">
                    </Column>
                    <Column header="Message" field="sm5" class="p-text-capitalize" headerStyle="width: 35%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.sm6 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.sm6 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editDynamicMessageModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add Message">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="modules">
                            Module
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="modules" v-model="modules" :options="modulesList" optionLabel="label"
                            placeholder="Select Module" appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.modules.$error">{{ v$.modules.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="screentitle">
                            Screen Title
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="screentitle" v-model="screentitle" required="true" maxlength="200"
                            placeholder="Enter Screen Title" :class="{ 'p-invalid': isSubmitted && !screentitle }" />
                        <small class="p-invalid p-error" v-if="v$.screentitle.$error">{{
                            v$.screentitle.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="dynamicmessage">Message <span class="p-invalid p-error">*</span></label>
                        <Textarea id="dynamicmessage" v-model="dynamicmessage" :autoResize="true" rows="3" cols="30"
                            placeholder="Enter Message" :class="{ 'p-invalid': isSubmitted && !message }"></textarea>
                        <!-- <InputText id="dynamicmessage" v-model="dynamicmessage" required="true" maxlength="30"
                            placeholder="Enter State Code" /> -->
                        <small class="p-invalid p-error" v-if="v$.dynamicmessage.$error">{{
                            v$.dynamicmessage.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addDynamicMessage" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit Message" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="modules">
                            Module
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="modules" v-model="modules" :disabled="isEditUserRole" :options="modulesList" optionLabel="label"
                            placeholder="Select Module" appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.modules.$error">{{ v$.modules.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="screentitle">
                            Screen Title
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="screentitle" v-model="screentitle" :disabled="isEditUserRole" required="true" maxlength="200"
                            placeholder="Enter Screen Title" :class="{ 'p-invalid': isSubmitted && !screentitle }" />
                        <small class="p-invalid p-error" v-if="v$.screentitle.$error">{{
                            v$.screentitle.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="dynamicmessage">Message <span class="p-invalid p-error">*</span></label>
                        <Textarea id="dynamicmessage" v-model="dynamicmessage" :autoResize="true" rows="3" cols="30"
                            placeholder="Enter Message" :class="{ 'p-invalid': isSubmitted && !message }"></textarea>
                        <!-- <InputText id="dynamicmessage" v-model="dynamicmessage" required="true" maxlength="30"
                            placeholder="Enter State Code" /> -->
                        <small class="p-invalid p-error" v-if="v$.dynamicmessage.$error">{{
                            v$.dynamicmessage.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body"></Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editDynamicMessage(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import { useConfirm } from "primevue/useconfirm";
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            dynamicsmessage: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            screentitle: '',
            modulesList: [],
            modules: '',
            dynamicmessage: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            stateFilter: '',
            localAdminName: '',
            stateFilterList: [],
        };
    },
    validations() {
        return {
            screentitle: { required: helpers.withMessage('Please enter screen title', required) },
            dynamicmessage: { required: helpers.withMessage('Please enter message', required) },
            modules: { required: helpers.withMessage('Please select modules', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        const route = useRoute();
        this.loading = true;
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.getDynamicScreenMessage({ maa1: this.routeParam });
        this.getAllAdminMenus({ maa1: this.routeParam });
    },
    methods: {
        getAllAdminMenus() {
            this.ApiService.getAllAdminMenus({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.modulesList = items.data;
                }
            })
        },
        getDynamicScreenMessage() {
            this.ApiService.getDynamicScreenMessage({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.dynamicsmessage = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.dynamicsmessage = [];
                }
                this.loading = false;
            });
        },
        async toDynamicMessage() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.screentitle = '';
            this.dynamicmessage = '';
            this.modules = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addDynamicMessage() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('sm2', this.modules?.value);
            formData.append('sm3', this.modules?.label);
            formData.append('sm4', this.screentitle);
            formData.append('sm5', this.dynamicmessage);
            formData.append('sm6', this.adminstatus?.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateDynamicScreenMessage(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getDynamicScreenMessage({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.screentitle = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editDynamicMessageModalOpen(data) {
            this.isEditUserRole = true;
            this.screentitle = '';
            this.dynamicmessage = '';
            this.adminstatus = '',
                this.rowId = data.sm1;
            this.screentitle = data.sm4;
            this.dynamicmessage = data.sm5;
            this.modules = this.modulesList.find((item) => item.value == data.sm2);
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.sm6);
        },
        editDynamicMessage() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('sm1', this.rowId);
            formData.append('sm2', this.modules?.value);
            formData.append('sm3', this.modules.label);
            formData.append('sm4', this.screentitle);
            formData.append('sm5', this.dynamicmessage);
            formData.append('sm6', this.adminstatus?.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateDynamicScreenMessage(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getDynamicScreenMessage({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.screentitle = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getDynamicScreenMessage({ page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "web-bot-template-settings-dashboard",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "notification",
                params: { adminSubId: this.routeParam },
            });
        },
    }
};
</script>

<style scoped></style>
